import React, { cloneElement } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Flex } from 'pcln-design-system'

const WrapperFlex = styled(Flex)`
  position: relative;
`

const CornerFlex = styled(Flex)`
  position: absolute;
  top: -5%;
  right: -37%;
`

const ICON_RATIO = 1.5

export default function ComposedIcon(props) {
  const { widthPx, className, icon, badgeIcon, description } = props

  const baseIcon = cloneElement(icon, { size: `${widthPx}px` })
  const badge = cloneElement(badgeIcon, { size: `${widthPx / ICON_RATIO}px` })

  return (
    <WrapperFlex
      className={className}
      mr={`${widthPx / 3}px`}
      width={`${widthPx}px`}
      aria-label={description}
    >
      {baseIcon}
      <CornerFlex>{badge}</CornerFlex>
    </WrapperFlex>
  )
}

ComposedIcon.defaultProps = {
  widthPx: 24,
}

ComposedIcon.propTypes = {
  icon: PropTypes.node.isRequired,
  badgeIcon: PropTypes.node.isRequired,
  className: PropTypes.string,
  widthPx: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
}
